import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Paper
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import api from "../../API";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";

interface props {
  did:any
  className?: string;
}

const EvalEVLTTextViewPage = (props: props) => {

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const [evltSentences, setEvltSentences] = useState<any>([]);
  const [selectedData, setSelectedData] = useState<any>(null);
  const [backdrop, setBackdrop] = useState<boolean>(false)

  const getEvltContextList = async () => {
  
    setBackdrop(true)
    api.get('/getContextDetail',{params:{email:email, document_id:props.did}})
    .then((res:any) => {

      const datas = res.data.datas;
      // console.log('백업 텍스트', datas)
      
      if(datas && datas.length > 0){
        setEvltSentences(res.data.datas);
        // 첫 번째 데이터 자동 선택
        setSelectedData(datas[0]);
      }
      setBackdrop(false)
      })
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
  }

  useEffect(() => {
    // getJson(props.data);
    getEvltContextList()

  }, [props.did]);

  const handleSelectChange = (event: any) => {
    const selectedId = event.target.value;
    const selectedItem = evltSentences.find(item => item.document_id === selectedId);
    if (selectedItem) setSelectedData(selectedItem);
  };

  return (
    <Box display="flex">
      <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#acdffc"}}>
        <Box sx={{width:"760px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
          <Box sx={{display:"flex", alignItems:"center"}}>
            <Box sx={{display:"flex", alignItems:"center"}}>
              <Box sx={{marginLeft:"4px"}}>
                <Box display="flex">
                  <Box>
                    <Box sx={{display:"flex", alignItems:"center", justifyContent:"left"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"120px"}}>document_id</Box>
                      <Select id="topic_cd" value={selectedData?.document_id || ""} onChange={handleSelectChange} sx={{backgroundColor: "#fff",color:"green",width:"340px", height: "28px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                      {(evltSentences && evltSentences.length > 0) && evltSentences.map((item:any, index:any) => 
                        <MenuItem key={index} dense value={item.document_id}>{item.idx}({item.document_id})</MenuItem>
                      )}
                      </Select>
                    </Box>
                    {/* <Box display="flex" sx={{marginTop:"8px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류</Box>
                      <Select id="topic_cd" value={selectedData?.category || ""} sx={{backgroundColor: "#fff",color:"green",width:"340px", height: "28px", marginLeft: "54px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        <MenuItem dense value={""}>선택하세요</MenuItem>
                        <MenuItem dense value={"101"}>한국형-역사</MenuItem>
                        <MenuItem dense value={"102"}>한국형-문화</MenuItem>
                        <MenuItem dense value={"103"}>한국형-사회</MenuItem>
                        <MenuItem dense value={"104"}>한국형-지리</MenuItem>
                        <MenuItem dense value={"105"}>한국형-언어</MenuItem>
                        <MenuItem dense value={"106"}>한국형-정치및법</MenuItem>
                        <MenuItem dense value={"201"}>글로벌-일반상식</MenuItem>
                        <MenuItem dense value={"202"}>글로벌-과학</MenuItem>
                        <MenuItem dense value={"203"}>글로벌-인문학및사회학</MenuItem>
                        <MenuItem dense value={"204"}>글로벌-공학및기술</MenuItem>
                        <MenuItem dense value={"205"}>글로벌-경제</MenuItem>
                        <MenuItem dense value={"206"}>글로벌-기타</MenuItem>
                      </Select>
                    </Box> */}
                  </Box>
                  {/* <Box sx={{marginLeft:"16px"}}>
                    <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                    <Box><textarea value={selectedData?.keyword || ""} spellCheck="false" style={{width:"450px",minHeight:"28px", fontSize:"12px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box> */}
                </Box>
                <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                <Box><textarea value={selectedData?.document_title || ""} spellCheck="false" style={{width:"740px",minHeight:"32px", fontSize:"12px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                <Box><textarea value={selectedData?.context || ""} spellCheck="false" style={{width:"740px",minHeight:"260px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

              </Box>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default EvalEVLTTextViewPage;
